import {
  backgroundImageLinearGradient,
  mq,
  propToBottom,
} from '@sleepstation/style-api-helpers'
import { reversedAltTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import defaultHeroStarscapes from '../../../../svg/starscapes/hero'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const sizeIsSmallDown = (size) => size === `xSmall` || size === `small`

const toBackgroundImage =
  (size) =>
  ({ images, hideStarsAtSmallDown }) => {
    const image = images[size]
    const showBackground = !(sizeIsSmallDown(size) && hideStarsAtSmallDown)

    return showBackground
      ? {
          backgroundImage: `url(${image.url})`,
          backgroundPosition: image.position,
        }
      : {
          backgroundImage: `none`,
        }
  }

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: relative;
  overflow: hidden;
  margin-bottom: 0 !important;
  ${backgroundImageLinearGradient()}
`

const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  ${propToBottom(`imageOffsetBottom`)}
  background-repeat: no-repeat;

  ${mq(`xSmallOnly`)} {
    ${toBackgroundImage(`xSmall`)}
  }

  ${mq(`smallOnly`)} {
    ${toBackgroundImage(`small`)}
  }

  ${mq(`mediumUp`)} {
    ${toBackgroundImage(`medium`)}
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HeroBreakoutModule = ({
  children,
  images,
  imageOffsetBottom,
  hideStarsAtSmallDown,
  theme,
}) => (
  <ThemeProvider theme={theme}>
    <Layout className="breakout">
      <Image
        images={images}
        imageOffsetBottom={imageOffsetBottom}
        hideStarsAtSmallDown={hideStarsAtSmallDown}
      />
      {children}
    </Layout>
  </ThemeProvider>
)

HeroBreakoutModule.propTypes = {
  children: PropTypes.node.isRequired,
  images: PropTypes.object,
  imageOffsetBottom: PropTypes.number,
  hideStarsAtSmallDown: PropTypes.bool,
  theme: PropTypes.object,
}

HeroBreakoutModule.defaultProps = {
  images: defaultHeroStarscapes,
  imageOffsetBottom: 3,
  hideStarsAtSmallDown: false,
  theme: reversedAltTheme,
}

export default HeroBreakoutModule
